import React from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {closeShuma} from '../../../../../_common/actions/oldInspectionDetailsActions';
import {copyOrderFileToShuma, deleteFile, getFile, getFileList} from '../../../../actions/TabDocumentsActions';
import ButtonAction from '../../../../../_common/components/ButtonAction';
import {toAbsoluteUrl} from '../../../../../../../_metronic/_helpers';
import FileNamePreview from './FileNamePreview';
import {showGlobalMessage} from '../../../../../_common/components/GlobalMessage/actions/showGlobalMessage';
import {messages as M} from '../../../../../../../_metronic/i18n/messages';
import {useOldInspectionDocumentsContext} from '../../../OldInspectionsDocumentsContext';
import styles from './styles.module.scss';

interface FileItemProps {
  fileID: number,
  fileName: string,
  fileExtension: string,
  fileTypeName: string,
  fileTypeID: number,
  orderID: number,
  shumaID: number,
  allowDownloadFile: boolean,
  allowDeleteFile: boolean,
  allowSelectFile: boolean,
  closePopup: () => void,
  showFileTypeColumn?: boolean,
}

export function FileItem({
                           fileID,
                           fileName,
                           fileExtension,
                           fileTypeName,
                           fileTypeID,
                           orderID,
                           shumaID,
                           allowDownloadFile,
                           allowDeleteFile,
                           allowSelectFile,
                           closePopup,
                           showFileTypeColumn = true
                         }: FileItemProps) {
  const dispatch = useDispatch();
  const location = useLocation<number[]>();
  const shumaOriginID = Boolean(location.state) ? location.state[0] : null;
  const {updateFileList} = useOldInspectionDocumentsContext();

  const handleDownloadFile = (shumaID: number, fileID: number, fileName: string) => {
    try {
      dispatch(getFile({shumaID, fileID, fileName}));
    } catch (e) {
      console.error(e);
    }
  };
  const handleDeleteFile = async (shumaID: number, fileID: number) => {
    try {
      await dispatch(deleteFile({shumaID, fileID}));
      await dispatch(getFileList(shumaID));
    } catch (e) {
      console.error(e);
    }
  };
  const handleSelectFile = async (orderID: number, shumaID: number, orderFileID: number, fileTypeID: number) => {
    try {
      const result = await copyOrderFileToShuma({orderID, shumaID, orderFileID, fileTypeID});
      await updateFileList();
      dispatch(showGlobalMessage(
        result === 0 ? 'success' : 'error',
        M[result === 0 ? '0' : '-1'])
      );

      if (fileTypeID === 21 && shumaOriginID === 3) {
        await dispatch(closeShuma(shumaID));
      }
      await dispatch(getFileList(shumaID));
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        closePopup();
      }, 50);
    }
  };

  return (
    <div key={fileID} className={styles.row}>
      <div className={styles.cell}>
        <FileNamePreview fileName={fileName} fileExtension={fileExtension} orderID={orderID}/>
      </div>
      {showFileTypeColumn && (
        <div className={styles.cell}>
          {fileTypeName}
        </div>
      )}
      {allowDeleteFile && (
        <ButtonAction
          variant={'icon'}
          iconButtonType={'error'}
          onClick={() => handleDeleteFile(shumaID, fileID)}
          label={<img src={toAbsoluteUrl('/media/common/Delete_red.svg')} alt="icon"/>}
        />
      )}
      {allowDownloadFile && (
        <ButtonAction
          variant={'icon'}
          iconButtonType={'secondary'}
          onClick={() => handleDownloadFile(shumaID, fileID, fileName)}
          label={<img src={toAbsoluteUrl('/media/common/Download_secondary.svg')} alt="icon"/>}
        />
      )}
      {allowSelectFile && (
        <ButtonAction
          variant={'icon'}
          iconButtonType={'primary'}
          onClick={() => handleSelectFile(orderID, shumaID, fileID, fileTypeID)}
          label={<img src={toAbsoluteUrl('/media/common/Check_primary.svg')} alt="icon"/>}
        />
      )}
    </div>
  );
}
